import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SupplementService } from 'src/app/service/supplement.service';
import { DialogComponent } from './../../core/dialog/dialog.component';

@Component({
    selector: 'app-supplements',
    templateUrl: './supplements.component.html',
    styleUrls: ['./supplements.component.scss'],
    standalone: false // NOSONAR
})
export class SupplementsComponent {

  suppCd: string = "";
  OrderNo: string = "";
  enableError: boolean = false;
  enableSubmit: boolean = false;
  suppErrorMsg: string = "";
  OrdNoErrorMsg: string = "";
  truckTypes: { trailerTypeId: number, truck: string, trailerType: string }[] = [];
  truckTyesTemp: any = [];
  truckSelected: { trailerTypeId: number, truck: string, trailerType: string } | null = null;
  truckTypeChoosen = '';


  ngOnInit(): void { // NOSONAR
    this.truckTyesTemp = localStorage.getItem('Truck-Types');
    this.truckTypes = this.truckTyesTemp ? JSON.parse(this.truckTyesTemp) : [];
    this.truckSelected = this.truckTypes.length > 0 ? this.truckTypes[0] : null;
    console.info("Truck Types: " + this.truckSelected);
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.trailerTypeId == o2.trailerTypeId : o1 == o2;; // NOSONAR
  }

  constructor(private readonly suppService: SupplementService, private readonly ngxUiLoaderService: NgxUiLoaderService
    , private readonly dialog: MatDialog
  ) { }


  view() {
    console.info("Supplier Code: " + this.suppCd);
    console.info("Order Number: " + this.OrderNo);
    const userInfo = localStorage.getItem('user-info');
    const userDetails = userInfo ? JSON.parse(userInfo) : [];

    const obj = {
      "MANIFEST_ID": undefined, "ERROR_CODE": undefined, "ERROR_DESCRIPTION": undefined, "ORGID": undefined,
      "PDF_URL": undefined
    };
    this.ngxUiLoaderService.start("loader-01");

    const requestData = {
      "suppCd": this.suppCd,
      "orderNumber": this.OrderNo,
      "trailerId": this.truckSelected?.trailerTypeId,
      "truck": this.truckSelected?.trailerType,
      "userDetails": userDetails
    };



    this.suppService.getSuppData(requestData).subscribe(result => {

      console.info("API Response:", result);

      const data = result?.MLP_OPTIMIZE_LOAD;

      if (Array.isArray(data) && data.length > 0) {
        const pdfLinks = data.map(item => ({
          PDF_URL: item?.PDF_URL?.trim(),
          ERROR_DESCRIPTION: item?.ERROR_DESCRIPTION?.trim(),
        })).filter(item => item.PDF_URL);

        const errorExists = data.filter(item => item?.ERROR_CODE !=  "0"); // NOSONAR

        if (pdfLinks.length > 0) {
          // Display PDF links in the dialog
          this.openDialog({
            message: `PDF links for Supplier Code: ${this.suppCd} and Order Number: ${this.OrderNo}:`,
            pdfLinks,
            errorExists: null,
          });
        } else if (errorExists.length > 0) {
          // Display errors in the dialog
          this.openDialog({
            message: `Error(s) for Supplier Code: ${this.suppCd} and Order Number: ${this.OrderNo}:`,
            pdfLinks: null,
            errorExists,
          });
        } else {
          // No PDF links or specific errors
          this.openDialog({
            message: `No PDF exists for Supplier Code: ${this.suppCd} and Order Number: ${this.OrderNo}.`,
            pdfLinks: null,
            errorExists: null,
          });
        }
      } else {
        // No data received
        this.openDialog({
          message: `No data received from the API for Supplier Code: ${this.suppCd} and Order Number: ${this.OrderNo}.`,
          pdfLinks: null,
          errorExists: null,
        });
      }

      this.ngxUiLoaderService.stop("loader-01");
    }, error => {
      console.info("Error fetching supplier data:", error);
      this.openDialog({
        message: `An error occurred while fetching the data for Supplier Code: ${this.suppCd} and Order Number: ${this.OrderNo}. Please try again.`,
        pdfLinks: null,
        errorExists: null,
      });
      this.ngxUiLoaderService.stop("loader-01");
    });

    console.info("Object Data" + obj);



  }

  validateInput() {

    if (this.suppCd == null || this.suppCd == '' || this.suppCd == undefined) { // NOSONAR
      this.suppErrorMsg = 'Enter Supplier Code';
    } else {
      this.suppErrorMsg = this.suppCd.length < 5 ? 'Supplier Code is 5 Characters' : '';
    }

    if (this.OrderNo == null || this.OrderNo == '' || this.OrderNo == undefined) { // NOSONAR
      this.OrdNoErrorMsg = 'Enter Order No#';
    }

    else if (!this.OrderNo.includes('S', 10)) {
      this.OrdNoErrorMsg = 'Include "S" in Order No# at 11th Position';
    }
    else {
      console.info(this.OrderNo.length);
      this.OrdNoErrorMsg = this.OrderNo.length < 10 ? 'Order No# should more 10 Characters' : '';
    }


    this.enableError = this.suppErrorMsg  !=  "" ? true : false; // NOSONAR
    this.enableError = this.OrdNoErrorMsg  !=  "" ? true : false; // NOSONAR
    if (this.enableError) {
      this.enableSubmit = false;
    } else {
      this.enableSubmit = true;
    }
  }


  openDialog(data: { message: string; pdfLinks: any; errorExists: any }): void {
    this.dialog.open(DialogComponent, {
      data,
      width: '600px', // Adjust width if necessary
    });
  }

}
